import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getFunctions } from 'firebase/functions';
import { getAnalytics } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: "AIzaSyBHgN8gZAWn9e9zfnL1-tm3C8ixGrO-kbk",
  authDomain: "sensorlogic-c2bad.firebaseapp.com",
  projectId: "sensorlogic-c2bad",
  storageBucket: "sensorlogic-c2bad.firebasestorage.app",
  messagingSenderId: "159407237683",
  appId: "1:159407237683:web:6a713e32cec36b295cd146",
  measurementId: "G-P8WGH2C4WP"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);
export const analytics = getAnalytics(app);